import { CentralSemaforoCotacao } from '../buyer/semaforo-conversor/_models/cotacao';
declare const isEmpty: any;
declare const deepSetObj: any;
declare const $: any;

export const b64DecodeUnicode = (str) => {
    if (!str?.trim())
        return '';

    return decodeURIComponent(atob(str).split('').map(function(c) { return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2); }).join(''));
}

const buscarNovaPosicaoCotacao = (cotacoes: CentralSemaforoCotacao[], cotacao: any, callbackOrdenar: any) : number => {
    let cotacoesCopia = $.extend(true, [], cotacoes);
    const index = cotacoes.findIndex(q => q.quotation_id === cotacao.quotation_id);

    if (isEmpty(index) || index < 0)
        cotacoesCopia.push(cotacao);
    else
        deepSetObj(cotacoesCopia[index], cotacao);

    if (typeof callbackOrdenar === 'function')
        callbackOrdenar(cotacoesCopia);

    return cotacoesCopia.findIndex(q => q.quotation_id === cotacao.quotation_id);
}

export const capitalizeFirstLetter = (text: string) => {
    if (!text)
        return '';

    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const createDate = (inputDate: { year: number, month: number, day: number } | string): Date | undefined => {
    if (typeof inputDate != 'string') {
        return new Date(inputDate.year, inputDate.month - 1, inputDate.day);
    }

    if (inputDate != '' && inputDate.checkIfHasTwoSlashes()) {
        var dateParts = inputDate.split("/").map(d => parseInt(d));

        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
    }

    return null;
}

export const deepCopy = (object: any) => {
    if (!object)
        return null;

    const serializedObject = JSON.stringify(object);
    return JSON.parse(serializedObject);
}

export const fileSizeToMB = (file: File): number => {
    const conversionDivider = 1024 * 1024;
    return file.size / conversionDivider;
}

export const getScreenSizeIsMobile = () => {
    return !getIsInsideIframe() && window.innerWidth < 1024;
}

export const getBase64ImageSize = (base64String: string): number => {
    // Remove o cabeçalho base64 se presente
    const base64HeaderPattern = /^data:image\/[a-zA-Z]+;base64,/;
    const base64HeaderOctet = /^data:application\/octet-stream;base64,/;
    const base64WithoutHeader = base64String.replace(base64HeaderPattern, '').replace(base64HeaderOctet, '');

    // Calcule o comprimento da string base64 sem o cabeçalho
    const base64Length = base64WithoutHeader.length;

    // Contar o número de caracteres de preenchimento '='
    const padding = (base64WithoutHeader.match(/=/g) || []).length;

    // Calcule o tamanho em bytes
    const sizeInBytes = (base64Length * 3 / 4) - padding;

    return sizeInBytes;
}

export const inputFileToBase64 = (file: File) => new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => resolve(reader.result.toString());

    reader.onerror = error => reject(error);
});

export const formatDateToMonthTextAndYear = (date: Date): string => {
    if (!date)
        return '';

    let month = new Intl.DateTimeFormat('pt-BR', { month: 'short' }).format(date);

    // Remove ponto final (se existir) e deixa a primeira letra maiúscula
    month = month.replace('.', '').toLowerCase();
    month = month.charAt(0).toUpperCase() + month.slice(1);

    const year = String(date.getFullYear()).slice(-2);

    return`${month}/${year}`;
}


export const getFilenameFromUrl = (url: string): string => {
    const proxyUrl = 'https://cors-anywhere.herokuapp.com/' + url;

    // Cria um objeto URL a partir da string da URL
    const urlObject = new URL(proxyUrl);

    // Extrai o caminho da URL
    const pathname = urlObject.pathname;

    // Divide o caminho em segmentos e obtém o último segmento
    const segments = pathname.split('/');
    const filename = segments.pop() || segments.pop(); // Trata o caso de URL com barra no final

    return filename;
}

export const getIsInsideIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export const handleOnDropFile: ($event) => File[] = ($event) => {
    const result: File[] = [];

    if ($event.dataTransfer.items) {
        for (const item of $event.dataTransfer.items as DataTransferItem[]) {
            if (item.kind !== 'file')
                return;

            result.push(item.getAsFile());
        }
    } else {
        for (const file of $event.dataTransfer.files as File[]) {
            result.push(file);
        }
    }

    return result;
}

export const inDelay = (someDate) =>
{
    if (!someDate)
        return false;

    var today = zeraHoraMinutoSegundo(new Date());
    var dateToCompare = zeraHoraMinutoSegundo(someDate);

    return dateToCompare.getTime() < today.getTime();
}

export const inserirCotacaoNaLista = (cotacoes: CentralSemaforoCotacao[], cotacao: any, posicaoAtual: number, callbackOrdenar: any, callbackAtualizarCotacoes: any) => {
    const novaPosicao = buscarNovaPosicaoCotacao(cotacoes, cotacao, callbackOrdenar); // Encontra a nova posição da cotação

    if (posicaoAtual >= 0)
        cotacoes.splice(posicaoAtual, 1);

    cotacoes.splice(novaPosicao, 0, cotacao);

    if (typeof callbackAtualizarCotacoes === 'function')
        callbackAtualizarCotacoes();
}

export const removeHTMLTags = (text: string) => {
    return text.replace(/(?!<(img[^>]+)>)(<([^>]+)>)/gi, "").trim();
}

export const getBrandIdByShortName = (brandList: any[], shortName: string) => {
    let shortNameFilter = shortName.toUpperCase();
    let id = brandList.find(x => x.name.toUpperCase() == shortNameFilter || x?.short_name?.includes(shortNameFilter))?.id;
    return id ?? -1;
}

export const zeraHoraMinutoSegundo = (data: Date) => {
    data.setHours(0);
    data.setMinutes(0);
    data.setSeconds(0, 0);

    return data;
}
